import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const ProductWidgetGallaryLayoutStyle = styled.div`
  padding: 0 15px;

  img {
    width: 100%;
  }
`;
